<div class="row no-gutters" [ngClass]="{ 'bold': bold }">

    <div class="col-sm-6">
        {{ label | translate }}
        <span class="plus-min" [ngClass]="{ 'plus': !negative, 'min': negative }">{{ negative ? '-' : (negative === false ? '+' : '') }}</span>
    </div>

    <div *ngIf="showSecondValueColumn"
         class="currency-column-2 col-sm-3 text-right" [ngClass]="{ 'underline': underline }">
        <span [ngClass]="{ 'iq-color-2': colored && val_2 >= 0, 'iq-color-warn': colored && val_2 < 0 }">
            {{ val_2 | drCurrency : '' }}
        </span>
        <span class="net-gross-separator">/</span>
    </div>

    <div class="currency-column-1 text-right" [ngClass]="{ 'col-sm-3': showSecondValueColumn, 'col-sm-6': !showSecondValueColumn, 'underline': underline }">
        <span [ngClass]="{ 'iq-color-2': colored && val_1 >= 0, 'iq-color-warn': colored && val_1 < 0 }">
            {{ val_1 | drCurrency }}
        </span>
    </div>

</div>
